export default __webpack_public_path__ + "static/media/jazz.f7e3c4b8.png";